// extracted by mini-css-extract-plugin
export default {"marker":"Maps_marker__Ie4hP"};